module.exports = __webpack_public_path__ + "static/media/svgicons8-assistive_technology.dae94a01.svg";